import axios from "axios";
import React, { useEffect, useState, useContext } from "react";
import { Link } from "react-router-dom";
import { AuthContext } from "../context/authContext";

const Pictures = () => {
  const { currentUser } = useContext(AuthContext);
  const [pictures, setPictures] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get("/api/pictures");
        setPictures(res.data);
      } catch (err) {
        console.log(err);
      }
    };
    fetchData();
  }, []);

return (
    <div className="pictures-page">
<h1>pictures</h1>
      <div className="picture-grid">
        {pictures.map((pic) => (
          <Link className="link" to={`/picture/${pic.id}`} key={pic.id}>
            <div className="picture-tile">
              <img src={`/upload/${pic.img}`} alt={pic.caption || "photo"} />
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default Pictures;
